
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 58 58","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M52.563 45.313H27.186l-14.5 10.874V45.313h-7.25a3.625 3.625 0 01-3.625-3.626V5.438a3.625 3.625 0 013.625-3.625h47.126a3.625 3.625 0 013.624 3.625v36.25a3.625 3.625 0 01-3.624 3.626z","stroke":"#3B3B3B","stroke-width":"3.625","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M18.125 22.656a.906.906 0 100 1.813.906.906 0 000-1.813zm10.875 0a.906.906 0 100 1.813.906.906 0 000-1.813zm10.875 0a.906.906 0 100 1.813.906.906 0 000-1.813z","stroke":"#3B3B3B","stroke-width":"3.625","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    